<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row" v-if="whiteList.length > 0">
        <div class="sixteen wide column">
          <h3>Whitelisted sellers</h3>
                <table class="ui very basic compact table">
                  <thead>
                    <tr>
                      <th class="two wide">Seller ID</th>
                      <th class="one wide">Marketplace</th>
                      <th class="one wide">Link</th>
                      <th class="four wide">Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="w in whiteList" :key="w.url">
                      <td>{{w.sellerId}}</td>
                      <td>{{w.marketplace}}</td>
                      <td><a v-bind:href="w.url" target="_blank">link</a></td>
                      <td><button class="mini basic ui icon button" v-on:click="removeFromWhiteList(w.url)"><i class="close icon"></i></button></td>
                    </tr>
                  </tbody>
                </table>
        </div>
      </div>
      <div class="row">
        <div class="three wide column">
          <div class="field">
            <button class="ui button submit" type="submit" :class="{'disabled':whiteListURLParsed == null}" v-on:click="addToWhiteList">Whitelist Seller by Feedback Page URL</button>
          </div>
        </div>
        <div class="eight wide column">
          <div class="ui form">
            <div class="field" :class="{'error':whiteListURLError}">
              <input type="text" v-model="whiteListURL" placeholder="Seller Feedback URL" required="required" v-on:keyup.enter="addToWhiteList" />
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="whiteListURLError">
        <div class="sixteen wide column">
          <div class="ui error message">
            <div class="header">Wrong URL format</div>
              <p style="padding-top:15px">Expecting URL for a seller's feedback page, for example: <a v-bind:href="this.whiteListURLErrorURL" target="_blank">{{this.whiteListURLErrorURL}}</a></p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      marketplaceDomains: ['www.amazon.com', 'www.amazon.ca', 'www.amazon.com.mx', 'www.amazon.co.uk', 'www.amazon.de', 'www.amazon.fr', 'www.amazon.es', 'www.amazon.it'],
      marketplaces: ['US', 'CA', 'MX', 'UK', 'DE', 'FR', 'ES', 'IT'],
      whiteList: [],
      whiteOrig: new Set(),
      whiteListURL: '',
      whiteListURLParsed: null,
      whiteListURLError: false,
      whiteListURLErrorURL: null,
      loading: true,
      dirty: false,
    }
  },
  props: ['watchDogType'],
  methods: {
    addToWhiteList: function () {
      if (this.whiteListURLParsed == null) return
      if (this.whiteList.filter(w => w.url === this.whiteListURLParsed.url).length === 0) {
        this.whiteList.splice(this.whiteList.length, 0, this.whiteListURLParsed)
      }
      this.whiteListURLParsed = null
      this.whiteListURLError = false
      this.whiteListURL = ''
    },
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/' + this.watchDogType).then((response) => {
        this.loading = false
        if (!response.body.whiteList) return
        const wl = response.body.whiteList
        const res = []
        const marketplaces = Object.keys(wl)
        for (let i = 0; i < marketplaces.length; ++i) {
          const m = marketplaces[i]
          const l = wl[m].sellerKeys
          for (let j = 0; j < l.length; ++j) {
            const e = l[j]
            res.splice(res.length, 0, {
              marketplace: m,
              sellerId: e.value,
              url: 'https://' + this.marketplaceDomains[this.marketplaces.indexOf(m)] + '/sp?seller=' + e.value
            })
          }
        }
        this.whiteList = res.sort((a, b) => {
          const mIdxA = this.marketplaces.indexOf(a.marketplace)
          const mIdxB = this.marketplaces.indexOf(b.marketplace)
          if (mIdxA < mIdxB) return -1
          if (mIdxB < mIdxA) return 1
          return a.sellerId.localeCompare(b.sellerId)
        })
        this.whiteListOrig = new Set(res.map(u => u.url))
      }, (response) => {
        this.loading = false
      })
    },
    save: function () {
      const wl = {}
      for (let i = 0; i < this.whiteList.length; ++i) {
        const w = this.whiteList[i]
        if (wl[w.marketplace]) {
          const sellerKeys = wl[w.marketplace].sellerKeys
          sellerKeys.splice(sellerKeys.length, 0, {value: w.sellerId})
        } else {
          wl[w.marketplace] = {sellerKeys: [{value: w.sellerId}]}
        }
      }
      const res = {whiteList: wl}
      this.$http.put('/api/sentinel/watchdogtype/settings/' + this.watchDogType, res
      ).then((response) => {
        this.whiteListOrig = new Set(this.whiteList.map(u => u.url))
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = !this.eqSet(this.whiteListOrig, new Set(this.whiteList.map(w => w.url)))
    },
    eqSet: function (as, bs) {
      if (as.size !== bs.size) return false
      for (var a of as) if (!bs.has(a)) return false
      return true
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    removeFromWhiteList: function (url) {
      for (let i = 0; i < this.whiteList.length; ++i) {
        const w = this.whiteList[i]
        if (url === w.url) {
          this.whiteList.splice(i, 1)
          break
        }
      }
    },
    getWhiteListURLErrorURL: function () {
      try {
        if (this.$store.getters.sellers) {
          const sellers = Object.values(this.$store.getters.sellers)
          if (sellers.length === 0) return 'https://www.amazon.com/sp?marketplaceID=ATVPDKIKX0DER&seller=AHI6RGNHINEJM'
          return sellers[0].storeFrontURL
        }
      } catch (err) {
      }
      return 'https://www.amazon.com/sp?marketplaceID=ATVPDKIKX0DER&seller=AHI6RGNHINEJM'
    },
  },
  created: function () {
    this.load()
  },
  watch: {
    whiteListURL: function (val) {
      if (!val) {
        this.whiteListURLParsed = null
        this.whiteListURLError = false
        this.whiteListURLErrorURL = null
        return
      }
      try {
        const url = new URL(val)
        const domainIdx = this.marketplaceDomains.indexOf(url.host)
        const sellerId = url.searchParams.get('seller')
        if (domainIdx > -1 && sellerId) {
          const cleanUrl = 'https://' + url.host + '/sp?seller=' + sellerId
          this.whiteListURLParsed = {marketplaceIdx: domainIdx, sellerId: sellerId, marketplace: this.marketplaces[domainIdx], url: cleanUrl}
          this.whiteListURLError = false
          this.whiteListURLErrorURL = null
        } else {
          this.whiteListURLParsed = null
          this.whiteListURLError = true
          this.whiteListURLErrorURL = this.getWhiteListURLErrorURL()
        }
      } catch (e) {
        this.whiteListURLParsed = null
        this.whiteListURLError = true
        this.whiteListURLErrorURL = this.getWhiteListURLErrorURL()
      }
    },
    whiteList: {
      handler: function () {
        this.updateDirty()
      },
      deep: true,
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// StoreFrontWhiteListConfig.vue?5d362266